import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { ValuesList } from '../../../UI/ValuesList/ValuesList';
import { useTranslation } from 'react-i18next';

export const EstimateMeasurementsParameters = () => {
    const { manualCalculations, additionallyList } = useSelector(
        (state) => state.measurementsReducer
    );

    const { t } = useTranslation();

    const values = useMemo(() => {
        const additionallyValues = Object.values(additionallyList.entities).map((elem) => ({
            title: elem.name,
            type: 'dimension',
            value: elem.value,
            unit: elem.unit,
            dimensionId: elem.id,
        }));

        return [
            {
                title: t('EstimateMeasurementsParameters.return.title.length'),
                type: 'length',
                value: manualCalculations.length,
                unit: t('EstimateMeasurementsParameters.return.unit'),
            },
            {
                title: t('EstimateMeasurementsParameters.return.title.width'),
                type: 'width',
                value: manualCalculations.width,
                unit: t('EstimateMeasurementsParameters.return.unit'),
            },
            {
                title: t('EstimateMeasurementsParameters.return.title.height'),
                type: 'height',
                value: manualCalculations.height,
                unit: t('EstimateMeasurementsParameters.return.unit'),
            },
            ...additionallyValues,
        ];
    }, [
        manualCalculations.length,
        manualCalculations.width,
        manualCalculations.height,
        additionallyList,
    ]);
    return (
        <>
            {!!values.length && (
                <ValuesList
                    title={t('EstimateMeasurementsParameters.return.ValuesList.title')}
                    values={values}
                />
            )}
        </>
    );
};
